module.exports = __webpack_public_path__ + "img/mini-punto-verde.265c47fa.png";